import { Link } from "react-router-dom";

export function LegalMeta({ updated }) {
  return updated ? <p className="legal-meta muted">Last updated {updated}</p> : null;
}

export function LegalSection({ id = "", title, paragraphs = [], steps = [], children }) {
  return (
    <section id={id || undefined} className="legal-section">
      {title ? <h2>{title}</h2> : null}
      {paragraphs.map((text) => (
        <p key={text.slice(0, 48)}>{text}</p>
      ))}
      {steps.length ? (
        <ol>
          {steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      ) : null}
      {children}
    </section>
  );
}

export function LegalCrossLinks() {
  return (
    <nav className="legal-crosslinks" aria-label="Related policies">
      <Link to="/eula">End User License Agreement</Link>
      <Link to="/disclaimer">Disclaimer</Link>
      <Link to="/privacy">Privacy</Link>
      <Link to="/terms">Terms of use</Link>
      <Link to="/backup">Backup &amp; export</Link>
    </nav>
  );
}
